import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { XIcon } from "lucide-react";
import { ease } from "../utils/styles";
import { RequestForm } from "./RequestForm";
interface RequestModalProps {
  open: boolean;
  onClose: () => void;
}
export function RequestModal({
  open,
  onClose
}: RequestModalProps) {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = "hidden";
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-381" data-mp="2v0no3r8ptas6">
      {open && <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-6" data-id="element-382" data-mp="2v1pb8u309nq9">
          <motion.div className="absolute inset-0 bg-ink/40" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} data-id="element-383" data-mp="390yeyua0ypdc" />
          <motion.div role="dialog" aria-modal="true" aria-labelledby="req-title" className="relative w-full max-w-xl rounded-t-2xl bg-paper p-6 sm:rounded-2xl sm:p-8" initial={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease
      }} data-id="element-384" data-mp="swtdaxwy36de">
            <div className="mb-6 flex items-start justify-between gap-4" data-id="element-385" data-mp="1fvy1jtjetfd6">
              <div data-id="element-386" data-mp="1fu4ptztxw4yb">
                <h3 id="req-title" className="text-2xl font-medium tracking-[-0.02em] text-ink" data-id="element-387" data-mp="1kmo654k0he6t">
                  Maatwerk aanvragen
                </h3>
                <p className="mt-1 text-sm text-muted" data-id="element-388" data-mp="1pkfz81we76cl">We reageren persoonlijk op iedere aanvraag.</p>
              </div>
              <button type="button" onClick={onClose} aria-label="Sluiten" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sand hover:bg-stone" data-id="element-389" data-mp="1umopgqhvrub0">
                <XIcon className="h-5 w-5" data-id="element-390" data-mp="19wkwwp0agxdz" />
              </button>
            </div>
            <RequestForm onDone={onClose} data-id="element-391" data-mp="14xrhgr1fywb6" />
          </motion.div>
        </div>}
    </AnimatePresence>;
}